<template>
  <dsf-navbar-item
    v-bind="$attrs"
    dsf_icon="CirclePlus"
    :dsf_title="$t('navigation.item.add-new-cargo')"
    dsf_id="create_shipment"
    @navigate.stop="onAddShipmentClick"
    :disabled="!loaded"
  />
  <component :is="mfWrapper"></component>
</template>

<script setup lang="ts">
import { onMounted, ref, shallowRef } from 'vue'

import {
  MicrofrontendEvents,
  showCreateShipmentFlow,
  publish,
} from '@sennder/senn-node-microfrontend-event-bus'
import { createMfWrapper, ComponentDefinition } from '@sennder/shell-utilities'

import { logger } from '@/services/logger/loggers'
import router from '@/router'
import {
  getRenderer,
  MFRepositories,
  Repositories,
} from '@sennder/microfrontend-registry'

const loaded = ref(false)
const mfWrapper = shallowRef<ComponentDefinition>()

const onAddShipmentClick = () => {
  publish<showCreateShipmentFlow>({
    name: MicrofrontendEvents.showCreateShipmentFlow,
    data: {},
  })
}

onMounted(async () => {
  mfWrapper.value = await createMfWrapper({
    id: Repositories[MFRepositories.Shipment].meta.fml.npmName,
    renderer: getRenderer(MFRepositories.Shipment, 'createShipment', {
      integrator: 'SennTMS',
    }),
    router,
    hooks: {
      failure: logger.error,
    },
  })

  loaded.value = true
})
</script>
